<template>
  <div id="app" class="out">
    <header id="header">
      <div class="wrapper">
        <router-link id="logo" to="/"
          ><img src="/img/logo.svg" alt="" />
        </router-link>
        <a
          class="contact"
          target="_blank"
          href="mailto:joerendell@googlemail.com"
          >Contact Me</a
        >
      </div>
    </header>

    <div class="wrapper" v-if="videos">
      <div class="showReelWrapper">
        <div id="showReel">
          <span v-html="videos[0].embed"></span>
        </div>
      </div>

      <div id="bio">
        
        <div class="copy">

          <img src="/img/joe-rendell.jpg" class="image" />
          <h1 style="font-size: 1.5rem;font-weight:bold;margin-bottom:20px">
            Motion Graphic Designer, Video Editor, and Filmmaker based in Leeds, West Yorkshire.
          </h1>

          <p>
            I bring a passion for creativity to a variety of projects, from engaging video ads and YouTube tutorials to music videos, short films, commercials, and corporate content.
          </p>

          <p>
            When I'm not behind the screen, I love collaborating with like-minded artists, agencies, and individuals to co-create something truly exceptional.
          </p>

          <img style="width: 200px" src="/img/sig.svg" alt="" />
        </div>
      </div>

      <ul id="videos">
        <li v-for="video in compVideos" :key="video.uri">
          <a href="#">
            <img
              @click.prevent="playVid(video)"
              :src="video.thumbnail"
              alt=""
            />
          </a>
        </li>
      </ul>
    </div>

    <router-view />

    <p class="footer">&copy; {{ year }} Joe Rendell, All Rights Reserved!</p>

    <div id="videoFrame" v-show="vidOpen" @click.prevent.self="exitFullScreen">
      <div ref="theinput" class="input">
        <div id="video">
          <vue-plyr ref="plyr">
            <div data-plyr-provider="vimeo" data-plyr-embed-id="76979871"></div>
          </vue-plyr>
        </div>
        <a href="" @click.prevent="exitFullScreen" class="close">CLOSE VIDEO</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  watch: {
    "$store.state.activeVideo": function ($new) {
      if ($new) {
        this.player.config.controls = [
          "play-large",
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "captions",
          "settings",
          "pip",
          "airplay",
          "fullscreen",
        ];

        this.player.config.autoplay = true;

        var $id = $new.uri.replace("/videos/", "");

        this.player.source = {
          type: "video",
          sources: [
            {
              src: $id,
              provider: "vimeo",
            },
          ],
        };
      }
    },
  },
  data: function () {
    return {
      videos: false,
      vidOpen: false,
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      var el = document.getElementById("app");

      el.classList.remove("out");
    });
  },
  created() {
    window.axios
      .get("https://api.joerendell.com/api/videos")
      .then((response) => {
        this.videos = response.data;
      });
  },
  computed: {
    player: function () {
      return this.$refs.plyr.player;
    },
    compVideos() {
      //var videos = this.videos.splice(0,1);
      return this.videos.slice(1);
    },
    year() {
      var d = new Date();
      return d.getFullYear();
    },
  },
  methods: {
    exitFullScreen: function () {
      document.body.classList.remove("hidden");
      this.vidOpen = false;
      this.player.stop();
      this.$store.state.playButtonLoading = false;
      this.$refs.theinput.scrollTop = 0;
    },
    playVid: function ($video) {
      document.body.classList.add("hidden");
      this.$store.state.activeVideo = $video;
      this.vidOpen = true;

      this.$nextTick(() => {
        this.player.play();
      });
      //this.player.fullscreen.enter()
    },
  },
};
</script>

<style lang="less">
html,
body {
  background: #131313;
  &.hidden {
    overflow: hidden;
  }
}
* {
  box-sizing: border-box;
}
.contact {
  color: white;
  position: absolute;
  right: 20px;
  top: 25px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
#bio {
  margin: 20px;
  padding: 40px;
  background: black;
  border: 1px solid #2f2d2d;
  border-radius: 3px;
  color: white;
  line-height: 1.5;
  position: relative;
  text-align: center;
  p {
    margin-bottom: 20px;
  }
 img.image {
      width: 150px;
      margin:0 auto;
      display:block;
      border-radius: 5px;
      margin-bottom:20px;

  }
  @media (max-width: 737px) {
    padding-left: 20px;
    text-align: center;
    margin-left: 0px;
    margin-right: 0px;
    .image {
      position: static;
      margin: 0 auto;
      margin-bottom: 20px;
      //display:none;
    }
  }
}
.footer {
  padding: 20px;
  text-align: center;
  background: black;
  color: white;
}
#showReel {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 35px;
  height: 0;
  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.showReelWrapper {
  background: black;
  border: 1px solid #2f2d2d;
  border-radius: 3px;
  margin-top: 90px;
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px;

  @media (max-width: 600px) {
    margin-left: 0px;
    margin-right: 0px;
  }
}
#videos {
  display: flex;
  flex-wrap: wrap;
  li {
    display: inline-block;
    flex: 0 0 ~"calc(25% - 40px)";
    margin: 20px;

    @media (max-width: 800px) {
      flex: 0 0 ~"calc(50% - 40px)";
    }

    @media (max-width: 600px) {
      flex: 0 0 100%;
      margin: 0px;
      margin-bottom: 20px;
    }
    a {
      display: block;
      padding: 5px;
      background: black;
      border: 1px solid #2f2d2d;
      border-radius: 3px;
      img {
        width: 100%;
      }
    }
  }
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #131313;
  opacity: 1;
  transition: opacity 1s;
  //padding-bottom:500px;
  &.out {
    opacity: 0;
  }
}

#header {
  height: 68px;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  background: black;

  .wrapper {
    margin-top: 0px;
  }

  #logo {
    text-decoration: none;
    font-weight: BOLD;
    font-size: 1.7rem;
    margin-top: 16px;
    display: inline-block;
    margin-left: 14px;
    width: 155px;
    img {
      width: 100%;
    }
  }
}

.wrapper {
  width: ~"calc(100% - 100px)";
  margin: 0 auto;
  margin-top: 60px;
}
#videoFrame {
  position: fixed;
  top: 0px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  box-sizing: border-box;

  .input {
    padding-bottom: 56.25%;
    padding-top: 35px;
    height: 0;
    overflow: hidden;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  .close {
    color: white;
    text-align: center;
    display: block;
    margin-top: 20px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}

[v-cloak] {
  display: none;
}
</style>
